import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

/**
 * Fixed pill shown at the bottom of the screen when the kiosk is serving
 * data from the local cache because the network is unavailable.
 * Fades in/out; does not intercept pointer events.
 */
const OfflineBanner = ({ show }) => {
  const [mounted, setMounted] = useState(show);

  useEffect(() => {
    if (show) {
      setMounted(true);
    } else {
      const t = setTimeout(() => setMounted(false), 400);
      return () => clearTimeout(t);
    }
  }, [show]);

  if (!mounted) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: '1.75rem',
        left: '50%',
        transform: 'translateX(-50%)',
        background: '#1a1a2e',
        color: '#fff',
        padding: '0.6rem 1.4rem',
        borderRadius: '999px',
        fontSize: '0.85rem',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        boxShadow: '0 4px 20px rgba(0,0,0,0.35)',
        zIndex: 9999,
        opacity: show ? 1 : 0,
        transition: 'opacity 0.35s ease',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
      }}
    >
      <WifiOff size={15} />
      Sin conexión — mostrando información guardada
    </div>
  );
};

export default OfflineBanner;
